(function () {
  'use strict';

  var popover = null;
  var sourcePreview = null;
  var pinned = false;
  var hoverCapable =
    window.matchMedia &&
    window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function addStyles() {
    if (document.getElementById('TokenMakerCartZoomStyles')) return;

    var style = document.createElement('style');
    style.id = 'TokenMakerCartZoomStyles';
    style.textContent = [
      '.tm-cart-preview[data-tm-zoom-ready="true"]{cursor:zoom-in;}',
      '.tm-cart-preview[data-tm-zoom-ready="true"]:focus-visible{outline:2px solid currentColor;outline-offset:3px;}',
      '.tm-cart-zoom-popover{display:none;position:fixed;z-index:100000;width:min(560px,calc(100vw - 20px));max-width:560px;padding:14px;box-sizing:border-box;background:#fff;color:#111;border:1px solid rgba(0,0,0,.18);border-radius:8px;box-shadow:0 12px 34px rgba(0,0,0,.28);pointer-events:none;}',
      '.tm-cart-zoom-popover.is-pinned{pointer-events:auto;}',
      '.tm-cart-zoom-title{margin:0 34px 10px 0;font-size:13px;line-height:1.2;font-weight:700;}',
      '.tm-cart-zoom-close{display:none;position:absolute;top:6px;right:7px;width:34px;height:34px;padding:0;border:0;background:transparent;color:#111;font-size:26px;line-height:1;cursor:pointer;}',
      '.tm-cart-zoom-popover.is-pinned .tm-cart-zoom-close{display:block;}',
      '.tm-cart-zoom-content .tm-cart-preview{display:flex!important;width:100%;gap:16px;align-items:flex-start;justify-content:center;margin:0 auto;}',
      '.tm-cart-zoom-content .tm-cart-side{flex:1 1 0;max-width:250px;text-align:center;}',
      '.tm-cart-zoom-content .tm-cart-hosted-preview,.tm-cart-zoom-content .tm-cart-token{width:100%;max-width:240px;}',
      '.tm-cart-zoom-content .tm-cart-side:only-child{max-width:340px;}',
      '.tm-cart-zoom-content .tm-cart-side:only-child .tm-cart-hosted-preview,.tm-cart-zoom-content .tm-cart-side:only-child .tm-cart-token{max-width:330px;}',
      '.tm-cart-zoom-content .tm-cart-side__label{margin-top:7px;font-size:12px;font-weight:700;opacity:.8;}',
      '@media(max-width:700px){.tm-cart-zoom-popover{width:calc(100vw - 20px);max-width:none;}.tm-cart-zoom-content .tm-cart-hosted-preview,.tm-cart-zoom-content .tm-cart-token{max-width:42vw;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function isReadyPreview(element) {
    if (!element || !element.matches) return false;
    if (!element.matches('.tm-cart-preview')) return false;

    var state = element.getAttribute('data-tm-rendered');
    return state === 'true' || state === 'hosted-preview';
  }

  function previewFromTarget(target) {
    if (!target || !target.closest) return null;
    var preview = target.closest('.tm-cart-preview');
    return isReadyPreview(preview) ? preview : null;
  }

  function decoratePreviews() {
    var previews = document.querySelectorAll('.tm-cart-preview');
    Array.prototype.forEach.call(previews, function (preview) {
      if (!isReadyPreview(preview)) return;

      preview.setAttribute('data-tm-zoom-ready', 'true');
      preview.setAttribute('tabindex', '0');
      preview.setAttribute('role', 'button');
      preview.setAttribute(
        'aria-label',
        'View larger Token Maker preview'
      );
      preview.setAttribute(
        'title',
        'Hover or click to view a larger token preview'
      );
    });

    if (
      sourcePreview &&
      !document.documentElement.contains(sourcePreview)
    ) {
      closeZoom(true);
    }
  }

  function ensurePopover() {
    if (popover) return popover;

    popover = document.createElement('div');
    popover.className = 'tm-cart-zoom-popover';
    popover.setAttribute('aria-hidden', 'true');
    popover.innerHTML =
      '<button type="button" class="tm-cart-zoom-close" aria-label="Close larger token preview">&times;</button>' +
      '<div class="tm-cart-zoom-title">Token preview</div>' +
      '<div class="tm-cart-zoom-content"></div>';

    document.body.appendChild(popover);

    popover.querySelector('.tm-cart-zoom-close')
      .addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeZoom(true);
      });

    return popover;
  }

  function positionZoom() {
    if (
      !popover ||
      !sourcePreview ||
      !document.documentElement.contains(sourcePreview)
    ) {
      closeZoom(true);
      return;
    }

    var sourceRect = sourcePreview.getBoundingClientRect();

    popover.style.display = 'block';
    popover.style.visibility = 'hidden';

    var popoverRect = popover.getBoundingClientRect();
    var gap = 14;
    var edge = 10;
    var left = sourceRect.left - popoverRect.width - gap;

    if (left < edge) {
      left = Math.min(
        window.innerWidth - popoverRect.width - edge,
        sourceRect.right + gap
      );
    }

    if (window.innerWidth <= 700) {
      left = Math.max(
        edge,
        (window.innerWidth - popoverRect.width) / 2
      );
    }

    var top =
      sourceRect.top +
      (sourceRect.height - popoverRect.height) / 2;

    top = Math.max(
      edge,
      Math.min(
        window.innerHeight - popoverRect.height - edge,
        top
      )
    );

    popover.style.left = Math.round(left) + 'px';
    popover.style.top = Math.round(top) + 'px';
    popover.style.visibility = 'visible';
  }

  function openZoom(preview, makePinned) {
    if (!isReadyPreview(preview)) return;

    var box = ensurePopover();
    var content = box.querySelector('.tm-cart-zoom-content');
    var clone = preview.cloneNode(true);

    [
      'data-tm-line-key',
      'data-tm-rendered',
      'data-tm-zoom-ready',
      'tabindex',
      'role',
      'aria-label',
      'title'
    ].forEach(function (attribute) {
      clone.removeAttribute(attribute);
    });

    content.innerHTML = '';
    content.appendChild(clone);

    sourcePreview = preview;
    pinned = Boolean(makePinned);

    box.classList.toggle('is-pinned', pinned);
    box.setAttribute('aria-hidden', 'false');

    positionZoom();
  }

  function closeZoom(force) {
    if (!popover) return;
    if (!force && pinned) return;

    popover.style.display = 'none';
    popover.style.visibility = 'hidden';
    popover.setAttribute('aria-hidden', 'true');
    popover.classList.remove('is-pinned');

    pinned = false;
    sourcePreview = null;
  }

  function relatedIsInside(preview, relatedTarget) {
    return Boolean(
      preview &&
      relatedTarget &&
      preview.contains &&
      preview.contains(relatedTarget)
    );
  }

  function handleMouseOver(event) {
    if (!hoverCapable || pinned) return;

    var preview = previewFromTarget(event.target);
    if (!preview) return;
    if (relatedIsInside(preview, event.relatedTarget)) return;

    openZoom(preview, false);
  }

  function handleMouseOut(event) {
    if (!hoverCapable || pinned) return;

    var preview = previewFromTarget(event.target);
    if (!preview || preview !== sourcePreview) return;
    if (relatedIsInside(preview, event.relatedTarget)) return;

    closeZoom(false);
  }

  function handleClick(event) {
    var preview = previewFromTarget(event.target);

    if (preview) {
      event.preventDefault();
      event.stopPropagation();

      if (pinned && sourcePreview === preview) {
        closeZoom(true);
      } else {
        openZoom(preview, true);
      }
      return;
    }

    if (
      popover &&
      popover.style.display !== 'none' &&
      !popover.contains(event.target)
    ) {
      closeZoom(true);
    }
  }

  function handleFocusIn(event) {
    var preview = previewFromTarget(event.target);
    if (preview && !pinned) openZoom(preview, false);
  }

  function handleFocusOut(event) {
    var preview = previewFromTarget(event.target);
    if (!preview || pinned) return;
    if (relatedIsInside(preview, event.relatedTarget)) return;
    closeZoom(false);
  }

  function handleKeyDown(event) {
    if (event.key === 'Escape') {
      closeZoom(true);
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') return;

    var preview = previewFromTarget(event.target);
    if (!preview) return;

    event.preventDefault();
    event.stopPropagation();

    if (pinned && sourcePreview === preview) {
      closeZoom(true);
    } else {
      openZoom(preview, true);
    }
  }

  function initialise() {
    addStyles();
    ensurePopover();
    decoratePreviews();

    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseout', handleMouseOut);
    document.addEventListener('click', handleClick);
    document.addEventListener('focusin', handleFocusIn);
    document.addEventListener('focusout', handleFocusOut);
    document.addEventListener('keydown', handleKeyDown);

    window.addEventListener('resize', function () {
      if (sourcePreview && popover && popover.style.display !== 'none') {
        positionZoom();
      }
    });

    window.addEventListener('scroll', function () {
      if (sourcePreview && popover && popover.style.display !== 'none') {
        positionZoom();
      }
    }, true);

    var cartContainer = document.getElementById('CartContainer');
    if (!cartContainer) return;

    new MutationObserver(decoratePreviews).observe(
      cartContainer,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-tm-rendered']
      }
    );

    var cartDrawer = document.getElementById('CartDrawer');

    if (cartDrawer) {
      new MutationObserver(function () {
        if (
          !cartDrawer.classList.contains('drawer--is-open') &&
          popover &&
          popover.style.display !== 'none'
        ) {
          closeZoom(true);
        }
      }).observe(
        cartDrawer,
        {
          attributes: true,
          attributeFilter: ['class']
        }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();